import { useContext, useEffect, useState } from "react";
import "./index.css";
import { useParams } from "react-router-dom";
import { AppContext } from "../../../context/AppContext";

const JobDetails = () => {
  const [careers, setCareers] = useState([]);
  const { setActiveRoute } = useContext(AppContext);

  useEffect(() => {
    setActiveRoute("/careers");
    const fetchDetails = async () => {
      try {
        const res = await fetch(
          "https://script.google.com/macros/s/AKfycbzbV9gKjyr9uMJUPSMS5FIHlKEp9ETWr3EP1bdvnSSG1RQY5A2-bPeOdAWx7Ez5qYEP2A/exec",
          {
            method: "GET",
            mode: "cors", // ✅ use "cors", NOT "no cors"
          },
        );
        const data = await res.json();

        setCareers(data);
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };

    fetchDetails();
  }, [setActiveRoute]);

  const { jobId } = useParams();
  const job = careers.find((j) => j.job_id === jobId);

  if (!job) {
    return (
      <div className="job-details-bg-container d-flex flex-column justify-content-center align-items-center">
        <p> Loading... Please Wait for a moment.</p>
      </div>
    );
  }
  return (
    <div className="job-details-bg-container">
      <div className="container mt-5 p-4 border rounded shadow bg-white">
        <h2 className="text-primary">{job.title}</h2>
        <p className="text-muted">{job.location}</p>

        <div className="mb-4">
          <h5>About Us</h5>
          <p>{job.about_us}</p>
        </div>

        <div className="mb-4">
          <h5>Role</h5>
          <ul>
            {job.role.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>

        <div className="mb-4">
          <h5>Responsibilities</h5>
          <ul>
            {job.responsibility.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>

        <div className="mb-4">
          <h5>Eligibility</h5>
          <ul>
            {job.eligibility.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>

        <div className="mb-4">
          <h5>Skills Required</h5>
          <ul>
            {job.skills_required.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>

        <div className="mb-4">
          <h5>Salary</h5>
          <p>{job.salary}</p>
        </div>

        <button className="btn btn-primary">
          {job.apply_link ? (
            <a
              href={job.apply_link}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              Apply
            </a>
          ) : (
            <button className="btn btn-primary">Apply</button>
          )}
        </button>
      </div>
    </div>
  );
};

export default JobDetails;
